export const fields = [
  {
    label: "Comment",
    name: "message",
    type: "textarea",
    disabled: true,
  },
  {
    label: "Display Status",
    name: "hidden",
    type: "toggle",
    required: true,
  },
]
